import {Component, OnInit} from '@angular/core';


@Component({
  selector: 'app-fund-switching',
  templateUrl: './fund-switching.component.html',
  styleUrls: [
    './../../../shared/style/main.scss',
    './fund-switching.component.scss'
  ]
})
export class FundSwitchingComponent implements OnInit {
  constructor() {
  }

  ngOnInit() {
  }
}
